import { render, staticRenderFns } from "./fakeTransactionsList.vue?vue&type=template&id=253fd322&scoped=true&"
import script from "./fakeTransactionsList.vue?vue&type=script&lang=js&"
export * from "./fakeTransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./fakeTransactionsList.vue?vue&type=style&index=0&id=253fd322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253fd322",
  null
  
)

export default component.exports